import type { LinkListItem } from "@/utils/mergeTagsToLinkList";

export interface CombinedLinkList {
  /** What to assign to `link_list`; undefined leaves the option unset. */
  linkList: unknown;
  /** Merge tags are the field's whole content, so it can be relabelled. */
  mergeTagsOnly: boolean;
}

/**
 * Combines a customer-supplied `link_list` (from `tinyConfig`) with the
 * merge-tag-derived list so neither clobbers the other in the link dialog.
 * When both exist, merge tags are appended as a single named group after the
 * customer's links. TinyMCE also accepts `link_list` as a URL string or a
 * function; those forms can't be concatenated, so the customer's value wins
 * and merge tags stay out of the dialog.
 */
export default function combineLinkLists(
  customerLinkList: unknown,
  mergeTagLinkList: LinkListItem[],
  mergeTagGroupTitle: string
): CombinedLinkList {
  const hasCustomerLinkList =
    customerLinkList !== undefined &&
    (!Array.isArray(customerLinkList) || customerLinkList.length > 0);

  if (!hasCustomerLinkList) {
    const hasMergeTags = mergeTagLinkList.length > 0;
    return {
      linkList: hasMergeTags ? mergeTagLinkList : undefined,
      mergeTagsOnly: hasMergeTags,
    };
  }

  if (!Array.isArray(customerLinkList) || mergeTagLinkList.length === 0) {
    return { linkList: customerLinkList, mergeTagsOnly: false };
  }

  return {
    linkList: [
      ...customerLinkList,
      { title: mergeTagGroupTitle, menu: mergeTagLinkList },
    ],
    mergeTagsOnly: false,
  };
}
